export default {
  showFormClass: (state, form) => {
    return (state.login.current_form == form) ? 'active' : ''
  }
}